import PropTypes from 'prop-types';
import styles from './Workspace.module.scss';

export const WorkspaceStartIcon = ({ variant }) => {
    return (
        <svg className={['govuk-button_start-icon', styles[variant]].join(' ')}
            data-testid='govuk-button_start-icon'
            xmlns="http://www.w3.org/2000/svg"
            width="17.5"
            height="19"
            viewBox="0 0 33 40"
            aria-hidden="true"
            focusable="false">
            <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z"/>
        </svg>
    );
};

WorkspaceStartIcon.propTypes = {
    variant: PropTypes.oneOf(['default', 'hsgbutton'])
};

WorkspaceStartIcon.defaultProps = {
    variant: 'default'
};

export default WorkspaceStartIcon;
